import { PIN_EXTENDED_TYPES, PIN_TYPES } from '@/microfrontends/map/shared/utils/mapModules/PinsLayer/types';

const WHITE = '#fff';
const BLACK = '#152242';
const PRIMARY_BLUE = '#0468FF';
const VIEWED_BLUE = '#83B4FF';

const blueWithWhiteBorder = { borderColor: WHITE, fillColor: PRIMARY_BLUE };
const blueWithBlueBorder = { borderColor: PRIMARY_BLUE, fillColor: PRIMARY_BLUE };
const lightBlueWithWhiteBorder = { borderColor: WHITE, fillColor: VIEWED_BLUE };
const lightBlueWithLightBlueBorder = { borderColor: VIEWED_BLUE, fillColor: VIEWED_BLUE };
const whiteWithBlueBorder = { borderColor: PRIMARY_BLUE, fillColor: WHITE };
const whiteWithLightBlueBorder = { borderColor: VIEWED_BLUE, fillColor: WHITE };

/**
 * Активное состояние для пина без балуна не принимаем во внимание, т.к. активное
 * состояние такого пина - это разметка поверх пина, стили самого пина в этом
 * случае не важны
 */
export const COLORS_CONFIG_MAP_WITHOUT_BALLOON = {
  /** Внутри гео */
  [PIN_TYPES.regular]: {
    default: { ...blueWithWhiteBorder, textColor: WHITE },
    /** Просмотренный пин - светло-синий с белой рамкой */
    [PIN_EXTENDED_TYPES.viewed]: { ...lightBlueWithWhiteBorder, textColor: WHITE },
  },
  /** Снаружи гео */
  [PIN_TYPES.regularOutsideGeo]: {
    default: { ...whiteWithBlueBorder, textColor: BLACK },
    /** Просмотренный пин - белый со светло-синей рамкой */
    [PIN_EXTENDED_TYPES.viewed]: { ...whiteWithLightBlueBorder, textColor: BLACK },
  },
};

export const COLORS_CONFIG_MAP_WITH_BALLOON = {
  /** Внутри гео */
  [PIN_TYPES.regular]: {
    default: { ...blueWithBlueBorder, textColor: WHITE },
    /** Активный пин - полностью синий, белая рамка не будет учтена */
    [PIN_EXTENDED_TYPES.active]: { ...blueWithWhiteBorder, textColor: WHITE },
    /** Просмотренный пин - полностью светло-синий */
    [PIN_EXTENDED_TYPES.viewed]: { ...lightBlueWithLightBlueBorder, textColor: WHITE },
    /** Пин промо с выделением */
    [PIN_EXTENDED_TYPES.glow]: { ...blueWithWhiteBorder, textColor: WHITE },
  },
  /** Снаружи гео */
  [PIN_TYPES.regularOutsideGeo]: {
    default: { ...whiteWithBlueBorder, textColor: WHITE },
    /** Активный пин - полностью синий, белая рамка не будет учтена */
    [PIN_EXTENDED_TYPES.active]: { ...blueWithWhiteBorder, textColor: WHITE },
    /** Просмотренный пин - белый со светло-синей рамкой */
    [PIN_EXTENDED_TYPES.viewed]: { ...whiteWithLightBlueBorder, textColor: BLACK },
    /** Пин промо с выделением */
    [PIN_EXTENDED_TYPES.glow]: { ...whiteWithBlueBorder, textColor: WHITE },
  },
};
